import _defineProperty from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useRef, useState } from 'react';
import { useMantineDefaultProps, extractSystemStyles, CloseButton, InputWrapper, Input } from '@mantine/core';
import { useUuid, useDidUpdate, useMergedRef } from '@mantine/hooks';
import useStyles from './TimeRangeInput.styles.js';
import { TimeInput } from '../TimeInput/TimeInput.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var RIGHT_SECTION_WIDTH = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
var defaultProps = {
  size: "sm",
  defaultValue: [null, null],
  withSeconds: false,
  clearable: false,
  format: "24",
  timePlaceholder: "--",
  amPmPlaceholder: "am",
  labelSeparator: "\u2013",
  disabled: false
};
var TimeRangeInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("TimeRangeInput", defaultProps, props),
      required = _a.required,
      label = _a.label,
      error = _a.error,
      description = _a.description,
      className = _a.className,
      style = _a.style,
      size = _a.size,
      wrapperProps = _a.wrapperProps,
      classNames = _a.classNames,
      styles = _a.styles,
      id = _a.id,
      value = _a.value,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      withSeconds = _a.withSeconds,
      clearable = _a.clearable,
      clearButtonLabel = _a.clearButtonLabel,
      format = _a.format,
      name = _a.name,
      hoursLabel = _a.hoursLabel,
      minutesLabel = _a.minutesLabel,
      secondsLabel = _a.secondsLabel,
      amPmLabel = _a.amPmLabel,
      timePlaceholder = _a.timePlaceholder,
      amPmPlaceholder = _a.amPmPlaceholder,
      labelSeparator = _a.labelSeparator,
      disabled = _a.disabled,
      sx = _a.sx,
      labelProps = _a.labelProps,
      descriptionProps = _a.descriptionProps,
      errorProps = _a.errorProps,
      others = __objRest(_a, ["required", "label", "error", "description", "className", "style", "size", "wrapperProps", "classNames", "styles", "id", "value", "defaultValue", "onChange", "withSeconds", "clearable", "clearButtonLabel", "format", "name", "hoursLabel", "minutesLabel", "secondsLabel", "amPmLabel", "timePlaceholder", "amPmPlaceholder", "labelSeparator", "disabled", "sx", "labelProps", "descriptionProps", "errorProps"]);

  var _useStyles = useStyles({
    size: size
  }, {
    classNames: classNames,
    styles: styles,
    name: "TimeRangeInput"
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var _extractSystemStyles = extractSystemStyles(others),
      systemStyles = _extractSystemStyles.systemStyles,
      rest = _extractSystemStyles.rest;

  var uuid = useUuid(id);
  var fromTimeRef = useRef();
  var toTimeRef = useRef();

  var _useState = useState(value != null ? value : defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      _value = _useState2[0],
      setValue = _useState2[1];

  useDidUpdate(function () {
    typeof onChange === "function" && onChange(_value);
  }, [_value]);
  useDidUpdate(function () {
    var _a2, _b, _c, _d;

    if (((_a2 = value[0]) == null ? void 0 : _a2.getTime()) !== ((_b = _value[0]) == null ? void 0 : _b.getTime()) || ((_c = value[1]) == null ? void 0 : _c.getTime()) !== ((_d = _value[1]) == null ? void 0 : _d.getTime())) {
      setValue(value);
    }
  }, [value]);

  var handleClear = function handleClear() {
    var _a2;

    setValue([null, null]);
    (_a2 = fromTimeRef.current) == null ? void 0 : _a2.focus();
  };

  var rightSection = clearable && _value.filter(function (item) {
    return Boolean(item);
  }).length > 0 ? /* @__PURE__ */React.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: handleClear,
    size: size
  }) : null;
  var forwardProps = {
    amPmLabel: amPmLabel,
    amPmPlaceholder: amPmPlaceholder,
    disabled: disabled,
    format: format,
    hoursLabel: hoursLabel,
    minutesLabel: minutesLabel,
    secondsLabel: secondsLabel,
    size: size,
    timePlaceholder: timePlaceholder,
    withSeconds: withSeconds
  };
  return /* @__PURE__ */React.createElement(InputWrapper, __spreadValues(__spreadValues({
    required: required,
    label: label,
    error: error,
    description: description,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    size: size,
    __staticSelector: "TimeRangeInput",
    id: uuid,
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React.createElement(Input, __spreadValues({
    component: "div",
    __staticSelector: "TimeRangeInput",
    required: required,
    invalid: !!error,
    onClick: function onClick() {
      var _a2;

      (_a2 = fromTimeRef.current) == null ? void 0 : _a2.focus();
    },
    size: size,
    className: cx(_defineProperty({}, classes.disabled, disabled)),
    classNames: classNames,
    styles: styles,
    disabled: disabled,
    rightSection: rightSection,
    rightSectionWidth: theme.fn.size({
      size: size,
      sizes: RIGHT_SECTION_WIDTH
    })
  }, rest), /* @__PURE__ */React.createElement("div", {
    className: classes.inputWrapper
  }, /* @__PURE__ */React.createElement(TimeInput, __spreadValues({
    ref: useMergedRef(fromTimeRef, ref),
    variant: "unstyled",
    value: _value[0],
    onChange: function onChange(date) {
      return setValue([date, _value[1]]);
    },
    name: name,
    nextRef: toTimeRef,
    id: uuid
  }, forwardProps)), /* @__PURE__ */React.createElement("span", {
    className: classes.separator,
    style: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
    }
  }, labelSeparator), /* @__PURE__ */React.createElement(TimeInput, __spreadValues({
    ref: toTimeRef,
    variant: "unstyled",
    value: _value[1],
    onChange: function onChange(date) {
      return setValue([_value[0], date]);
    }
  }, forwardProps)))));
});
TimeRangeInput.displayName = "@mantine/dates/TimeRangeInput";
export { TimeRangeInput };